<mat-toolbar>
  <mat-icon>dns</mat-icon>
  <span transloco="DATABASES"></span>
</mat-toolbar>
@if (isDatabasesLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="container">
  @for (database of databases$ | async; track database) {
    <button mat-raised-button [routerLink]="['db', database.id]">
      <span class="mat-headline-6">{{
        database.name | replace: databaseNameReplacement : ' '
      }}</span>
      <span class="spacer"></span>
    </button>
  }
</div>
